import { connect } from 'react-redux'

import { ticketVoucherAdd } from 'components/Basket/reducer'
import { qrLoaded } from '../../reducer'

const hocOrderSummary = (InnerComponent) => connect(null, { qrLoaded, ticketVoucherAdd })(InnerComponent)

export default hocOrderSummary
